<div class="score-input">
  @if (label()) {
    <span class="form-label" [id]="inputId() + '-label'">
      {{ label() }}
    </span>
  }

  <div
    class="score-input-options d-flex flex-nowrap justify-content-start gap-2"
    role="radiogroup"
    [attr.aria-labelledby]="label() ? inputId() + '-label' : null"
  >
    @for (option of radioOptions(); track option) {
      <label class="score-input-option-label flex-shrink-0 flex-grow-0">
        <span>{{ option }}</span>

        <input
          class="score-input-option-input"
          type="radio"
          [name]="inputId()"
          [id]="inputId() + '-' + option"
          [value]="option"
          [checked]="value() === option"
          (change)="onValueChange(option)"
          (blur)="onBlur()"
          [disabled]="disabled()"
          data-1p-ignore
          data-bwignore
          data-lpignore="true"
          data-form-type="other"
        />
      </label>
    }
  </div>
</div>
